import React from 'react';
import PropTypes from 'prop-types';

import Welcome from './welcome';
import PickClass from './pickclass';
import YourInfo from './yourinfo';
import ClassDetail from './classdetail';
import Finish from './finish';

export default class SignupProcess extends React.Component {
	static propTypes = {
		Code: PropTypes.object,
	};

	constructor( props ) { 
		super( props );

		let code = this.props.Code.substring( 1 );
		let step = parseInt( this.props.Code.substring( 0, 1 ) );

		this.state = { 
			step: step,
			code: code, 
			data: {}
		};

		window.onbeforeunload = () => {
			if( this.state.step === 5 || this.state.step === 1 ) { 
				return null;
			}
			return "You have not completed the signup, are you sure you want to navigate away?";
		};

		window.onpopstate = event => { 
			let state = {};
			if( event.state && event.state.step ) { state['step'] = event.state.step; }
			if( event.state && event.state.code &&  event.state.code !== this.state.code ) { 
				state[ 'code' ] = event.state.code;
				window.setTimeout( () => { 
					this.getSignupInfo();
				}, 20 );
			}
			this.setState( state );
		};

		this.markpos = [ 43, 154, 284, 416, 507 ];
		window.history.pushState( { step: this.state.step, code: this.state.code }, '', window.dt_js_details.currenturl + '?signup=' + ( this.state.step ) + '' + this.state.code );

		this.getSignupInfo();
	}

	resendVerify() {
		jQuery.ajax( {
			method: "POST",
			url: window.dt_js_details.ajax_url,
			data: { action: 'dt_resend_verify', 'email': this.state.data['email'] }
		} )
			.done( msg => {
				if( msg.success ) { 
					window.alert( 'Message Sent' );
					this.setState( { showELink: false } );
				} else { 
					window.alert( 'Failed to resend message' );
				}
			} )
			.fail( () => {
				window.alert( "Issue connecting to server to send mail" );
			} );
	}

	getSignupInfo() { 
		jQuery.ajax( {
			method: "POST",
			url: window.dt_js_details.ajax_url,
			data: { action: 'dt_get_signup_info', 'code': this.state.code }
		} )
			.done( msg => {
				if( msg ) {
					this.setState( { classlist: msg['classlist'], data: msg['userdata'] } );
				} else {
					window.alert( "Details was not found" );	
				}
			} )
			.fail( () => {
				window.alert( "Issue connecting to server" );
			} );
	}

	handleNext( i = null ) { 
		let s;
		if( i ) { 
			s = i; 
		} else { 
			s = this.state.step + 1;
		}

		if( s === 5 ) { 
			let data = { action: 'dt_signup_user', 'code': this.state.code, data: this.state.data };
			jQuery.ajax( {
				method: "POST",
				url: window.dt_js_details.ajax_url,
				data: data
			} )
				.done( msg => {
					if( msg['success'] ) { 
						this.setState( { step: 5 } );
						window.history.pushState( { step: 5, code: this.state.code }, '', window.dt_js_details.currenturl + '?signup=' + ( 5 ) + '' + this.state.code );
					} else { 
						window.alert( 'There was an error creating the new user: ' + msg['err'] );
						this.setState( { step: msg['movepage'] } );
					}
				} )
				.fail( () => {
					window.alert( "Issue connecting to server" );
				} );
		} else { 
			this.setState( { step: s } );
			window.history.pushState( { step: s, code: this.state.code }, '', window.dt_js_details.currenturl + '?signup=' + ( s ) + '' + this.state.code );
		}
	}

	handleChange( id, val ) {
		let d = this.state.data;
		d[ id ] = val;
		this.setState( { data: d } );

		if( this.savingTimer ) { 
			window.clearTimeout( this.savingTimer );
		}

		this.savingTimer = window.setTimeout( () => { this.saveChanges(); }, 400 );
	}

	saveChanges() {
		this.savingTimer = null;
		jQuery.ajax( {
			method: "POST",
			url: window.dt_js_details.ajax_url,
			data: { action: 'dt_set_signup_info', 'code': this.state.code, data: this.state.data }
		} )
			.done( () => {

			} )
			.fail( () => {
				window.alert( "Issue connecting to server" );
			} );
	}

	static willTransitionFrom( component, transition ) {
		if( !window.confirm( 'Are you sure you want to leave ?' ) ) {
			transition.abort();
		}
	}

	render() {
		return ( <div className="signupprocess_container">
			<div className="steps_list">
				<div className={  ( this.state.step === 1 ? 'selected_item ' : '' ) + 'step_item step1' } >
						Welcome
				</div>
				<div className={  ( this.state.step === 2 ? 'selected_item ' : '' ) + 'step_item step2' } >
						Select Class
				</div>
				<div className={  ( this.state.step === 3 ? 'selected_item ' : '' ) + 'step_item step3' } >
						Information
				</div>
				<div className={  ( this.state.step === 4 ? 'selected_item ' : '' ) + 'step_item step4' } >
						Setup Class
				</div>					
				<div className={  ( this.state.step === 5 ? 'selected_item ' : '' ) + 'step_item step5' } >
						Finish
				</div>
				<div className="marker" style={ { left: this.markpos[ this.state.step - 1 ] + 'px' } }>
				</div>
			</div>
				
			{ this.state.classlist ?
				<div>
					{ this.state.step === 1 ? 
						<Welcome onNextPage={ e => { this.handleNext( e ); } } 
							onChange={ ( id, val ) => { this.handleChange( id, val ); } } 
							data={ this.state.data }
							parent={ this }
						/> :
						[]
					}
					{ this.state.step === 2 ? 
						<PickClass 
							onNextPage={ e => { this.handleNext( e ); } } 
							onChange={ ( id, val ) => { this.handleChange( id, val ); } } 
							classList={ this.state.classlist }
							data={ this.state.data }
							parent={ this }
						/> :
						[]
					}
					{ this.state.step === 3 ? 
						<YourInfo onNextPage={ e => { this.handleNext( e ); } } 
							onChange={ ( id, val ) => { this.handleChange( id, val ); } } 
							data={ this.state.data }
							parent={ this }
						/> :
						[]
					}
					{ this.state.step === 4 ? 
						<ClassDetail onNextPage={ e => { this.handleNext( e ); } } 
							onChange={ ( id, val ) => { this.handleChange( id, val ); } } 
							classList={ this.state.classlist }
							data={ this.state.data }
							parent={ this }
						/> :
						[]
					}
					{ this.state.step === 5 ? 
						<Finish onNextPage={ e => { this.handleNext( e ); } } 
							onChange={ ( id, val ) => { this.handleChange( id, val ); } } 
							data={ this.state.data }
							parent={ this }
						/> :
						[]
					}
				</div> :
				<div>Please Wait, Loading...</div>
			} 
		</div>
		);
	}
}